<template>
    <div class="component-container">
        <div class="chart-canvas" id="trade"></div>
        <img class="banner" src="@/assets/images/bg-pic.png" alt="" />
    </div>
</template>

<script>
import * as echarts from "echarts";

import { mapState } from "vuex";
export default {
    data () {
        return {
            finalList: [],
            goodsCategories: [], //商品的类型
            tradeDate: [], //交易日期 类型：年 月 日
            startVal: 0, //区域缩放的起点值
            endVal: 5, //区域缩放的起点值
            timeId: null, //定时器的id
            myChart: undefined
        };
    },
    mounted () {
        this.initChart();
    },
    computed: {
        ...mapState(["dateType"]),
    },
    watch: {
        dateType (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getData();
            }
        },
    },
    destroyed () {
        //清除定时器
        clearInterval(this.timeId);
    },
    methods: {
        // 初始化表
        async initChart () {
            const chartDom = document.getElementById("trade");
            this.myChart = echarts.init(chartDom);
            await this.getData();
            this.startInterval();
            this.myChart.on("mouseover", () => {
                clearInterval(this.timeId);
            });
            this.myChart.on("mouseout", () => {
                this.startInterval();
            });
        },
        //获取后台的数据
        async getData () {
            await this.$http
                .get("/screen/getVehicleStatisticsForInCount?type=" + this.dateType, {})
                .then((response) => {
                    if (response.data.resultCode === 200) {
                        // // 日期列表
                        // let tradeDate = new Set();
                        this.finalList = [];
                        // // 获取日期
                        response.data.inList.forEach((dataOfDay) => {
                            if (this.dateType == 1 && new Date().getHours() >= Number(dataOfDay.time)) {  //日
                                // tradeDate.add(dataOfDay.time);
                                this.tradeDate.push(dataOfDay.time)
                                this.finalList.push(dataOfDay.result / 10000);
                            }
                            if (this.dateType == 2 && new Date().getDate() >= Number(dataOfDay.time)) {  //月
                                // tradeDate.add(dataOfDay.time);
                                this.tradeDate.push(dataOfDay.time)
                                this.finalList.push(dataOfDay.result / 10000);
                            }
                            if (this.dateType == 3 && new Date().getMonth() + 1 >= Number(dataOfDay.time)) {  //年
                                // tradeDate.add(dataOfDay.time);
                                this.tradeDate.push(dataOfDay.time)
                                this.finalList.push(dataOfDay.result / 10000);
                            }
                        });
                        // // 对日期从小到大排列
                        // this.tradeDate = [...tradeDate].sort();

                        // // 转换后的单价数据结构
                        // let parsedData = new Map();
                        // // 获取分类列表
                        // response.data.list.forEach((categoryInfo) => {
                        //     categoryInfo.data = new Array(this.tradeDate.length).fill(0); // 建立和日期等长的数据为0的数组
                        //     parsedData.set(categoryInfo.id, categoryInfo);
                        // });

                        // 设置数据
                        // this.finalList = [];
                        // response.data.inList.forEach((dataOfDay) => {
                        //     // let categoryInfo = parsedData.get(dataOfDay.id);
                        //     // if (
                        //     //     categoryInfo?.id &&
                        //     //     this.tradeDate.indexOf(dataOfDay.time) >= 0
                        //     // ) {
                        //     //     categoryInfo.data[this.tradeDate.indexOf(dataOfDay.time)] =
                        //     //         dataOfDay.result;
                        //     //     parsedData.set(categoryInfo.id, categoryInfo);
                        //     // }
                        //     if (this.dateType == 1 && new Date().getHours() >= Number(dataOfDay.time)) {  //日
                        //         this.finalList.push(dataOfDay.result / 10000);
                        //     }
                        //     if (this.dateType == 2 && new Date().getDate() >= Number(dataOfDay.time)) {  //月
                        //         this.finalList.push(dataOfDay.result / 10000);
                        //     }
                        //     if (this.dateType == 3 && new Date().getMonth() + 1 >= Number(dataOfDay.time)) {  //年
                        //         this.finalList.push(dataOfDay.result / 10000);
                        //     }
                        // });

                        // // 设置分类
                        // this.goodsCategories = [];
                        // this.finalList = [];
                        // parsedData.forEach((item) => {
                        //     this.goodsCategories.push(item.goodsname);
                        //     this.finalList.push(item);
                        // });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            this.startVal = 0;
            this.endVal = 5;
            this.showEcharts();
        },
        //展示折线图
        showEcharts () {
            const option = {
                title: {
                    text: "过磅收费走势",
                    left: "17",
                    top: "3",
                    textStyle: {
                        color: "#00C4FF",
                        fontWeight: 800,
                    },
                },
                tooltip: {
                    trigger: "axis",
                },
                // legend: {
                //     data: this.goodsCategories,
                //     top: 30,
                //     textStyle: {
                //         //图例文字的样式
                //         color: "#0CFEEE",
                //         fontSize: 20,
                //     },
                //     lineStyle: {
                //         color: "#f00",
                //     },
                //     icon: "circle",
                // },
                grid: {
                    left: "15%",
                    right: "12%",
                    bottom: "14%",
                    top: "38%",
                },
                toolbox: {},
                xAxis: {
                    type: "category",
                    name: "日期",
                    boundaryGap: false,
                    data: this.tradeDate, //x轴的数据
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: "#fff", //x轴的刻度线颜色
                            fontSize: 16,
                        },
                    },
                    nameTextStyle: {
                        color: "#0CFEEE", //坐标轴name颜色
                        fontSize: 18,
                    },
                },
                yAxis: {
                    type: "value",
                    show: true,
                    name: "金额(万)",
                    splitLine: false,
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: "#fff", //y轴的刻度线颜色
                            fontSize: 18,
                        },
                    },
                    nameTextStyle: {
                        color: "#0CFEEE", //坐标轴name颜色
                        fontSize: 17,
                    },
                },
                dataZoom: {
                    show: false,
                    startValue: this.startVal,
                    endValue: this.endVal,
                },
                series: [
                    {
                        data: this.finalList,
                        type: 'line',
                        smooth: true
                    }
                ],
                // series: this.finalList.map((item) => {
                //     return {
                //         name: item.goodsname,
                //         type: "line",
                //         stack: "Total",
                //         data: item.data,
                //     };
                // }),
            };
            option && this.myChart.setOption(option);
            this.myChart.resize()
        },
        startInterval () {
            // 判断定时器是否存在
            if (this.timeId) {
                clearInterval(this.timeId);
            }
            this.timeId = setInterval(() => {
                this.startVal++;
                this.endVal++;
                if (this.endVal > this.tradeDate.length - 1) {
                    this.startVal = 0;
                    this.endVal = 5;
                }
                this.showEcharts();
            }, 5000);
        },
    },
};
</script>

<style scoped>
</style>
